import { useMutation } from "@tanstack/react-query";
import { apiV1Endpoint } from "../../../../../../api/v1";
import { ApiResponse } from "../../../../../../types/api-response";
import axios from "../../../../../../utils/axiosInceptor";

export type ReceiptAllocationPayload = {
  pdcId: string;
  allocatedAmount: number;
};

export type ReceiptPaymentDetailsPayload = {
  paymentMode: string;
  paymentRef?: string;
  bankName?: string;
  depositDate?: string | null;
  depositTo?: string;
  depositToAccountNumber?: string;
  depositToBank?: string;
  depositToIBAN?: string;
  lessorAccountNumber?: string;
  lessorBankName?: string;
  branch?: string;
  swiftCode?: string;
  address?: string;
  note?: string;
};

export type UpdateAndIssueReceiptPayload = {
  leaseId: string;
  receiptAmount: number;
  applyOverpaymentCredit: boolean;
  allocations: ReceiptAllocationPayload[];
  paymentDetails?: ReceiptPaymentDetailsPayload;
};

const updateAndIssueReceipt = async (payload: UpdateAndIssueReceiptPayload) => {
  const url = `${apiV1Endpoint}/receipt/updateAndIssueReceipt`;
  const response = await axios.post<ApiResponse>(url, payload);
  return response.data;
};

type UseUpdateAndIssueReceiptOptions = {
  onSuccess?: (data: ApiResponse) => void;
  onError?: (error: unknown) => void;
};

export const useUpdateAndIssueReceipt = (options: UseUpdateAndIssueReceiptOptions = {}) => {
  const { onSuccess, onError } = options;

  const { mutateAsync, isPending } = useMutation({
    mutationFn: updateAndIssueReceipt,
    onSuccess,
    onError,
  });

  return {
    updateAndIssueReceipt: mutateAsync,
    isUpdatingAndIssuingReceipt: isPending,
  };
};
